module.exports = "<app-img-slider></app-img-slider>\r\n<app-intro-section></app-intro-section>"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/home/home.component.html
// module id = 783
// module chunks = 1